import React, { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ContactActionIds } from 'types/atoms/atom.contacts'
import { contactActionAtom } from '../atoms/contactAtoms'
import { ContactAssignSearch } from '../ContactAssignSearch'
import { ContactForm } from '../ContactForm'

interface ContactSheetProps {
  isSheetOpen: boolean
  isNestedSheet?: boolean
}

export const ContactsSheets = ({ isSheetOpen, isNestedSheet = false }: ContactSheetProps) => {
  const contactAction = useAtomValue(contactActionAtom)
  const { onBack, onClose, header, subHeader } = contactAction || {}

  const sheetContent = useMemo(() => {
    if (!contactAction) return null

    switch (contactAction?.actionId) {
      case ContactActionIds.CONTACT:
        return <ContactForm />
      case ContactActionIds.CONTACT_ASSIGN:
        return <ContactAssignSearch />
      default:
        return null
    }
  }, [contactAction])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
      isNestedSheet={isNestedSheet}
    >
      {sheetContent}
    </Sheet>
  )
}
